
export const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5234/api' : 'https://hexacthost.danfoss.com/HeAuth/api';
export const TOKEN_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5234/Token' : 'https://hexacthost.danfoss.com/HeAuth/Token';
